export const ft_fixText = (text?: string) : string => {
	if (!text)
		return '';
	while (text.includes('\r'))
		text = text.replace('\r', '');
	while (text.startsWith(' '))
		text = text.slice(1);
	while (text.endsWith(' '))
		text = text.slice(0, -1);
	return text;
};

export const ft_setVarText = (text?: string, ...vars: (string | number | undefined)[]) : string => {
	if (!text)
		return '';

	for (let i = 1; text.includes(`%var${i}%`) && vars[i - 1] !== undefined; i++)
		text = text?.replace(`%var${i}%`, `${vars[i - 1]}` || `%var${i}%`);

	return text;
};